/**
 * Safely decode a URI-encoded string.
 * Returns the original string if decoding fails.
 */
const decodeString = (str) => {
  if (!str) return str;
  try {
    return decodeURIComponent(str);
  } catch {
    return str;
  }
};

export default decodeString;
